import React, { useEffect } from 'react'
import { LoadingOverlay } from 'widgets/elemental/loading-overlay'
import { useLayoutBloC } from 'layout/layout.bloc'
import { Redirect } from 'react-router-dom'
import { Container } from 'reactstrap'
import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react'

import sidebarNavMenu from 'navigations/sidebar-nav-menu'
import PropTypes from 'prop-types'
import { Connector } from 'libs/mqtt-react'

import Header from 'layout/widgets/header'
import Outlet from 'layout/widgets/outlet'
import Footer from 'layout/widgets/footer'
import { getDB } from 'repositories/indexdb/db'

const PrivateLayout = (props = {}) => {
  const [layoutState] = useLayoutBloC()

  useEffect(() => {
    ;(async () => {
      const db = await getDB()
      const tx = db.transaction('files', 'readwrite')
      const store = tx.objectStore('files')
      const cutoff = Date.now() - 24 * 3600 * 1000 // 1 day

      // get the first cursor
      let cursor = await store.openCursor()
      while (cursor) {
        if (cursor.value.created < cutoff) {
          // delete by key
          await cursor.delete()
        }
        // advance to next record
        cursor = await cursor.continue()
      }

      await tx.done
    })()
  }, [])

  if (!layoutState.isAuthenticated) {
    return <Redirect to="/login" />
  }

  if (layoutState.isLoading) {
    return (
      <React.Fragment>
        <LoadingOverlay isOpen={layoutState.isLoading} />
        <Container>Loading ....</Container>
      </React.Fragment>
    )
  }
  const routes = layoutState.routes
  const mqtt = layoutState.mqtt
  const sidebarNav = sidebarNavMenu({
    summon: layoutState.summon,
    utm: layoutState.utm,
  })
  const dashboardAccount = layoutState.dashboardAccount
  return (
    <Connector broker={mqtt.broker} mqttProps={mqtt.option}>
      <div className="app">
        <AppHeader fixed>
          <Header
            {...props}
            dashboardAccount={dashboardAccount}
            summon={layoutState.summon}
            attendance={layoutState.attendance}
          />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={sidebarNav} {...props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <Outlet routes={routes} {...props} />
        </div>
        <AppFooter>
          <Footer />
        </AppFooter>
      </div>
    </Connector>
  )
}

PrivateLayout.propTypes = {
  location: PropTypes.any,
}

export default PrivateLayout
